export const getLineItemBySku = (sku, cart) =>
  (cart.lineItems || []).find(item => item.code.toString() === sku.toString())
